/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';

import GroupChannelHeader from '@sendbird/uikit-react/GroupChannel/components/GroupChannelHeader';
import { GroupChannelList } from '@sendbird/uikit-react/GroupChannelList';
import { GroupChannel } from '@sendbird/uikit-react/GroupChannel';
import '@sendbird/uikit-react/dist/index.css';
import { Box } from '@mui/system';

import {
  HelpUserTypes,
  PermissionsOfAdmin,
  userIdSelector,
  adminName,
  setSelectedClient,
  getAdminChannelUrl,
  channelsMetadata,
  getChannelProperties,
  setChatActiveTab,
  ClientChatTypes,
} from '@pharmaplan/common';

// eslint-disable-next-line import/no-unresolved
import { UserMessageCreateParams } from '@sendbird/chat/lib/__definition';
import GroupChannelPreviewBase from '../../common/Chat/GroupChannelPreviewBase';
import useAdminPermissions from '../../../hooks/Admin/useAdminPermissions';
import useUserProfileLink from '../../../hooks/Admin/useUserProfileLink';
import ChatManager from '../../../hooks/Chat/ChatManager';
import { useAppSelector } from '../../../hooks/useAppSelector';
import { useAppDispatch } from '../../../hooks/useAppDispatch';
import useNewMetadata from '../../../hooks/Chat/useNewMetadata';

import GroupChannelTitle from './GroupChannelTitle';
import CustomMessage from './CustomMessage';
import MessageInput from './MessageInput';
import GroupHeader from './GroupHeader';
import styles from './styles';
import './style.css';
import ChatSidebar from '../../common/Chat/ChatSidebar';

const ChatWindow = () => {
  const dispatch = useAppDispatch();
  const { can } = useAdminPermissions();
  const canViewEngaged = can(PermissionsOfAdmin.ViewEngagedChat);
  const channelMetadata = useAppSelector(channelsMetadata);

  const adminCreatedChannelProps = useAppSelector(getChannelProperties);
  const adminCreatedChannelUrl = useAppSelector(getAdminChannelUrl);

  const { channelName, personnelId, userType } = adminCreatedChannelProps ?? {};

  const { assignToCurrentUser } = ChatManager();

  const [firstMessage, setFirstMessage] = useState(false);
  const [channelUrl, setChannelUrl] = useState({
    url: '',
    channelName: '',
    personnelId: '',
    userType: '',
    isEngaged: false,
  });

  const userId = useAppSelector(userIdSelector);
  const adminUser = useAppSelector(adminName);

  const { goToUserProfile } = useUserProfileLink();

  const stub = () => {
    console.log('');
  };

  const beforeSendMessage = (params: UserMessageCreateParams) => {
    setFirstMessage(true);
    return params;
  };

  const handleChannelSelect = (channel: any) => {
    const { url, _name } = channel ?? {};
    const {
      user_type: inUserType,
      users,
      personnelId: inPersonnelId,
    } = channelMetadata?.[url] ?? {};

    const isEngaged = !!users && users !== userId;
    if (isEngaged && !canViewEngaged) return;

    setFirstMessage(false);
    dispatch(setSelectedClient(personnelId));
    setChannelUrl({
      userType: inUserType,
      personnelId: inPersonnelId,
      url: url ?? '',
      channelName: _name,
      isEngaged,
    });
  };

  useEffect(() => {
    if (firstMessage) {
      assignToCurrentUser(adminUser, userId, channelUrl.url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [firstMessage]);

  useEffect(() => {
    setChannelUrl((prev) =>
      ({
        ...prev,
        url: adminCreatedChannelUrl,
        channelName,
        userType,
        personnelId,
      }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adminCreatedChannelUrl]);

  useNewMetadata();

  useEffect(() => {
    dispatch(setChatActiveTab(ClientChatTypes.pharmacist));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box component="div" sx={styles.container}>
      <ChatSidebar />
      <GroupChannelList
        selectedChannelUrl={channelUrl.url}
        disableAutoSelect
        renderHeader={GroupHeader}
        isMessageReceiptStatusEnabled
        renderChannelPreview={(props) =>
          <GroupChannelPreviewBase {...props} />}
        onChannelSelect={handleChannelSelect}
        onChannelCreated={stub}
      />

      {channelUrl && (
        <GroupChannel
          onBeforeSendUserMessage={beforeSendMessage}
          onChatHeaderActionClick={goToUserProfile({
            personnelId: channelUrl.personnelId,
            userType:
              HelpUserTypes[channelUrl.userType as keyof typeof HelpUserTypes],
          })}
          channelUrl={channelUrl.url}
          renderChannelHeader={(props) =>
            (
              <GroupChannelHeader
                {...props}
                renderLeft={() =>
                  <div />}
                renderMiddle={() =>
                  (
                    <GroupChannelTitle
                      isViewingEngagedChannel={channelUrl.isEngaged}
                      title={channelUrl.channelName}
                      url={channelUrl.url}
                    />
                  )}
              />
            )}
          renderMessageInput={() =>
            (
              <MessageInput isEngaged={channelUrl.isEngaged} />
            )}
          renderMessage={CustomMessage}
        />
      )}
    </Box>
  );
};

export default ChatWindow;
